export const PDF_REPORT_SETTING = '_pdfReportSetting';
